<template>
  <section class="training-section container-fluid py-5">
    <div class="container">
 <div class="row align-items-center">
      <!-- Columna de texto -->
      <div class="col-lg-5  px-5">
        <h2 class="training-title mb-4">
          {{ content[selectedLang]?.title }}
        </h2>
        <p class="training-description mb-4">
          {{ content[selectedLang]?.description }}
        </p>
        <router-link :to="content[selectedLang]?.link" class="training-button" @click="goToServicio()">
          {{ content[selectedLang]?.button }}
        </router-link>
      </div>

      <!-- Imagen o ilustración -->
      <div class="col-lg-7">
        <img
          src="@/assets/images/training-visual.png"
          alt="Training Visual"
          class="img-fluid"
        />
      </div>
    </div>
    </div>
   
  </section>
</template>

<script>
import { defineComponent } from 'vue';
import { trainingSection as content } from '@/assets/data/data.ts';

export default defineComponent({
  name: 'TrainingSection',
  props: {
    selectedLang: {
      type: String,
      required: true
    }
  },
  methods: {
    goToServicio() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  },
  data() {
    return {
      content
    };
  }
});
</script>

<style scoped>
.training-section {
  background-color: #f3faf4;
  color: rgb(0, 0, 0);
}

.training-title {
  font-size: 2.5rem;
  font-weight: bold;
  
}

.training-description {
  font-size: 1.1rem;
  max-width: 500px;
}

.training-button {
  display: inline-block;
  background-color: #000000;
  color: white;
  padding: 0.5rem 1.5rem;
  border-radius: 999px;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.training-button:hover {
  background-color: #2c74b8;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.img-fluid {
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}

.img-fluid:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
</style>
